export const HERO_SECTION = {
  heading: "Smart Travel Begins with the Right Platform.",
  description: "Book ahead. Fly smart — globally with YatraBiz.",
  fields: [
    {
      label: "Ticket Holder Name",
      type: "text",
      placeholder: "Name on Ticket",
    },
    { label: "Flight Route", type: "text", placeholder: "E.g. Delhi to Dubai" },
    { label: "Date of Journey", type: "date" },
    { label: "Airline", type: "text", placeholder: "Airline Name" },
  ],
  button: "Search",
};

export const CAROUSEL = {
  slides: [
    {
      image: "/1.jpg",
      phrase: "Book smarter with flexible travel options — fast & fair.",
    },
    {
      image: "/2.jpg",
      phrase: "Global access to smarter flight choices for all.",
    },
    {
      image: "/3.jpg",
      phrase: "No penalties. No extra fees. Only freedom.",
    },
    {
      image: "/4.jpg",
      phrase: "Secure payments, trusted options, real value.",
    },
    {
      image: "/6.jpg",
      phrase: "Change plans? No problem — travel flexible with YatraBiz.",
    },
  ],
};


export const MAIN_HEADING =
  "The Smart Way to Book and Manage Flights Worldwide.";


  export const INFO_COLUMNS = [
    {
      heading: "Why Choose YatraBiz?",
      text: "YatraBiz transforms the way you plan and manage air travel. With flexible options, global access, and a seamless user experience, we make booking and rebooking simpler, faster, and smarter.",
    },
    {
      heading: "Travel on Your Terms",
      text: "Whether plans shift or opportunities open up, YatraBiz gives you control over how and when you fly. Set your preferences, explore available options, and take advantage of a platform built for modern travelers.",
    },
    {
      heading: "For Individuals and Businesses Alike",
      text: "YatraBiz supports both everyday travelers and organizations across the globe. With tools for bulk access, account management, and flexible flight solutions, we make air travel easier for everyone.",
    },
  ];
  

  export const OTHER_OFFERINGS_CARD = {
    label: "EXPLORE",
    title: "Browse Flexible Flight Options",
    buttonText: "See Listings",
    buttonLink: "/tickets",
  };
  